<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path d="M10.34 12.59 4.75 7H2l5.59 5.59-5.1 5.1h2.76l5.09-5.1Z" />
    <path d="M10.58 7H7.83l5.59 5.59-5.1 5.1h2.76l5.09-5.1L10.58 7Z" />
    <path d="m19.25 12.59-5.1 5.1h2.76l5.09-5.1L16.41 7h-2.75l5.59 5.59Z" />
  </svg>
</template>

<script>
export default {};
</script>
